export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "maxbet-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "maxbet-themeWrapLive" */'./LiveThemeImporter'),
  },
};
